module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedUltraBoldItalic.46cdc6b.eot";